const customStyles = {
  container: (base, state) => ({
    ...base,
  }),
  control: (base, state) => ({
    ...base,
    borderRadius: '8px',
    border: ' 2px solid var(--color-gp--blue-a)',
    background: '#f5fcff 0% 0% no-repeat padding-box',
    padding: '5px 15px 5px 15px',
    boxShadow: 'none',
    '&:hover': {
      outline: 'none',
    },
    cursor: 'pointer',
    minHeight: 'none',
    textAlign: 'center',
    backgroundColor: 'transparent',
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    position: 'absolute',
    right: 0,
    cursor: 'pointer',
    color: 'var(--color-gp--grey4)',
    '&:hover': {
      color: 'var(--color-gp--grey4)',
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    overflow: 'visible',
    height: '100%',
    padding: '0 0 0 0px',
  }),
  placeholder: (base, state) => ({
    ...base,
    position: 'absolute',
    top: '9px',
    fontFamily: 'Regular',
    fontSize: 12,
    color: 'var(--color-gp--grey4)',
    padding: '0px',
    whiteSpace: 'nowrap',
    margin: '0px',
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
      top: '4px',
    },
  }),
  input: (base, state) => ({
    ...base,
    position: 'absolute',
    bottom:
      (state.hasValue ||
        state.selectProps.inputValue ||
        state.selectProps.isFocused) &&
      '8px',
    padding: '0px',
    margin: '0px',
    fontFamily: 'Regular',
    fontSize: 16,
    caretColor: 'var(--color-gp--blue-a)',
    visibility: 'visible',
    color: 'var(--color-gp--grey4)',
    maxWidth: '85%',
    width: '128px',
    overflow: 'hidden',
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
      maxWidth: '90%',
      bottom:
        (state.hasValue ||
          state.selectProps.inputValue ||
          state.selectProps.isFocused) &&
        '5px',
    },
  }),
  singleValue: (base, state) => ({
    ...base,
    position: 'relative',
    padding: '0px',
    margin: '0px',
    fontFamily: 'Regular',
    fontSize: 16,
    textAlign: 'center',
    color: 'var(--color-gp--blue-a)',
    '@media only screen and (min-width: 768px)': {
      ...base['@media only screen and (min-width: 768px)'],
      fontSize: 15,
    },
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: '0px 0px 0px 8px',
    color: state.selectProps.isFocused
      ? 'var(--color-gp--blue-a)'
      : 'var(--color-gp--grey4)',

    '&:focus': {
      color: 'var(--color-gp--blue-a)',
    },
  }),
  menu: (base) => ({
    ...base,
    margin: '0px',
    boxShadow: '0px 3px 6px #0000003B',
    borderRadius: '4px',
    left: '0px',
  }),
  menuList: (base) => ({
    ...base,
    margin: '0px',
    maxHeight: '189px',
    /* width */
    '::-webkit-scrollbar': {
      width: '8px',
    },
    /* Track */
    '::-webkit-scrollbar-track': {
      boxShadow: 'none',
      borderRadius: 'none',
    },

    /* Handle */
    '::-webkit-scrollbar-thumb': {
      background: 'var(--color-gp--grey3)',
      borderRadius: '10px',
    },
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    padding: '10px 10px 10px 10px',
    color: 'var(--color-gp--grey6)',
    textAlign: 'center',
    backgroundColor: isSelected
      ? 'var(--color-gp--grey2)'
      : isFocused
      ? 'var(--color-gp--grey1)'
      : undefined,
    ':active': {
      backgroundColor: 'var(--color-gp--grey2)',
    },
  }),
};

export default customStyles;
